export default {
  lineStyle: {
    color: '#eeeeee',
    width: '1'
  },
  itemStyle: {
    normal: {
      color: '#cccccc',
      borderWidth: '1'
    },
    emphasis: {
      color: '#cccccc'
    }
  },
  controlStyle: {
    normal: {
      color: '#666666',
      borderColor: '#666666',
      borderWidth: 0.5
    },
    emphasis: {
      color: '#666666',
      borderColor: '#666666',
      borderWidth: 0.5
    }
  },
  checkpointStyle: {
    color: '#63ce7d',
    borderColor: 'rgba(99,206,84,0.3)'
  },
  label: {
    normal: {
      textStyle: {
        color: '#666666'
      }
    },
    emphasis: {
      textStyle: {
        color: '#666666'
      }
    }
  }
};